module.exports = __webpack_public_path__ + "img/lose.351fdc01.png";